<script>
  import { setLanguage } from "../../translations/index.js";
  
  const { language } = $props();
  
  // Environment URLs for different languages
  const env = {
      nl: 'https://theswarm.teamvismaleaseabike.nl/',
      en: 'https://theswarm.teamvismaleaseabike.com/',
  };
  
  // Handle language change by redirecting to the appropriate URL
  function handleLanguageChange(event) {
    setLanguage(event.target.value.split('/').pop().split('.')[0]);
    window.location.href = event.target.value;
  }
</script>

<select onchange={handleLanguageChange}>
  <option
    selected={language === "nl"}
    value={env.nl}
  >
    NL
  </option>
  <option
    selected={language === "en"}
    value={env.en}
  >
    EN
  </option>
</select>

<style>
  select {
    position: fixed;
    top: 8px;
    right: 8px;
    min-width: 48px;
    background: transparent;
    color: var(--color-yellow);
    border: none;
    padding: 0 24px 0 0;
    appearance: none;
    font-family: var(--font-heading);
    font-size: 16px;
    cursor: pointer;
    background-image: url('/images/icons/dropdown.svg');
    background-repeat: no-repeat;
    background-position: center right;
    background-size: 20px;
    letter-spacing: 2px;
    font-family: var(--font-body-wide);
    font-weight: 500;
    z-index: 100;

    @media screen and (min-width: 480px) {
        top: 16px;
        right: 16px;
    }

    @media (orientation: landscape) {
      top: 8px;
      right: 8px;
    }

    @media (orientation: landscape) and (min-width: 1200px) {
      top: 32px;
      right: 32px;
    }
  }
</style>